var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "activity-stage face-flip"
  }, [_vm.currentRound.steps ? _c('div', [_c('div', {
    ref: "faceCards",
    staticClass: "top"
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: step.imageLocation,
      staticClass: "card-item",
      attrs: {
        "transition": "kwtStagger"
      }
    }, [_c('flippable-card', {
      attrs: {
        "is-flipped": index === _vm.progress.stepIndex || _vm.showAllCards
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back"
      },
      slot: "card-back"
    }, [_c('img', {
      attrs: {
        "src": _vm.backOfCardPath
      }
    })]), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front"
      },
      slot: "card-front"
    }, [_c('img', {
      attrs: {
        "src": step.imageLocation
      }
    })])])], 1);
  }), 0), _c('div', {
    staticClass: "bottom"
  }, _vm._l(_vm.validStepsForTyping, function (step, index) {
    return _c('div', {
      key: ("text_" + index),
      staticClass: "td-container"
    }, [step.stepIndex === _vm.progress.stepIndex ? _c('blinking-cursor-text', {
      attrs: {
        "transition": "slide-in",
        "text": step.answer,
        "text-step": step.stepIndex
      }
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e()]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }